export const BLU_SMART_TGP_MODAL      = "BLU_SMART_TGP_MODAL"
export const HR_PACKAGE_DETAILS       = "HR_PACKAGE_DETAILS"
export const UPDATE_HR_PACKAGE        = "UPDATE_HR_PACKAGE"
export const UPDATE_HR_PACKAGE_TIME   = "UPDATE_HR_PACKAGE_TIME"
export const DEFAULT_HR_PACKAGE       = "DEFAULT_HR_PACKAGE"
export const DEFAULT_HR_PACKAGE_TIME  = "DEFAULT_HR_PACKAGE_TIME"
export const HOURLY_RENTALS_DETAILS   = "HOURLY_RENTALS_DETAILS"
export const OS_MODAL_DETAILS         = "OS_MODAL_DETAILS"
export const AT_MODAL_DETAILS         = "AT_MODAL_DETAILS"
export const CAB_TYPE_DETAIL_MODAL    = "CAB_TYPE_DETAIL_MODAL"
export const UPDATE_TRIP_TYPE         = "UPDATE_TRIP_TYPE"
export const SET_ONEWAY_CAB           = "SET_ONEWAY_CAB"
export const ONEWAY_INTERLINKING_DATA = "ONEWAY_INTERLINKING_DATA"
export const UPDATE_SOURCE_LOCUS      = "UPDATE_SOURCE_LOCUS"
export const UPDATE_DESTINATION_LOCUS = "UPDATE_DESTINATION_LOCUS"
export const UPDATE_TRAVELLER_DETAILS = "UPDATE_TRAVELLER_DETAILS"
export const UPDATE_HYDRA_SEGMENT     = "UPDATE_HYDRA_SEGMENT" 